import { render, staticRenderFns } from "./LobbyWaiting.vue?vue&type=template&id=6ded31f0&scoped=true&"
import script from "./LobbyWaiting.vue?vue&type=script&lang=js&"
export * from "./LobbyWaiting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ded31f0",
  null
  
)

export default component.exports